import { PROD, PROD_GTM, UAT_GTM } from '@/constants';
import { useGetHost } from '@/hooks/useRouteSection';
import i18next from '@/i18n/config';
import GlobalStyle from '@/theme/global-style';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { Script } from 'gatsby';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';
import { store } from '../../store';
import { theme } from '../../theme/theme';
import Header from './Header';
import { FeatureFlagsSync } from './FeatureFlagsSync';

declare global {
  interface Window {
    dataLayer: Array<any>;
  }
}

const Layout = (props: any) => {
  const host = useGetHost() || '';
  const GTMCode = host.includes(PROD) ? PROD_GTM : UAT_GTM;

  return (
    <Provider store={store}>
      <Script id="first-unique-id">
        {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-${GTMCode}');
            `}
      </Script>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <OpenFeatureProvider>
          <FeatureFlagsSync />
          {<Header />}
          <Styles>
            <I18nextProvider i18n={i18next}>{props.children}</I18nextProvider>
          </Styles>
          {/* {<Footer />} */}
        </OpenFeatureProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default Layout;

const Styles = styled.div`
  margin: 0px auto;
  padding-top: 0px;
  min-height: calc(100vh - 10rem);
  background: #f0f0f0 bottom no-repeat;
`;
